import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { DEALER_PROPS, REVIEWS_ALL, REVIEWS_SALES, REVIEWS_SERVICE } from 'client/constants/dealer-reviews';
import { WriteAReviewLink } from 'site-modules/shared/components/write-review-link/write-review-link';

import './dealer-review-no-reviews-view.scss';

export function DealerReviewNoReviewsView({
  params,
  showroomPage = '',
  isMobile = false,
  reviewsType: reviewsTypeFromProps = REVIEWS_SALES,
}) {
  const reviewsType = reviewsTypeFromProps === REVIEWS_ALL ? REVIEWS_SALES : reviewsTypeFromProps;

  return (
    <div className="no-reviews-view text-center">
      <div className="mb-3 pos-r">
        <img
          className={classnames('no-reviews-img', { desktop: !isMobile })}
          src={getStaticImageUrl('/img/dealer-no-reviews.svg')}
          alt=""
          decoding="async"
          loading="lazy"
        />
        <div className="pos-a mx-auto bottom-0 w-100">
          <p className="no-reviews-view-dealership mb-0_5 size-24 fw-bold">No {reviewsType} reviews (yet)</p>
          <p className="size-16 mb-0">Be the first to write a {reviewsType} review.</p>
        </div>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-md-between row-gap-1 rounded-16 bg-blue-100 p-1 p-md-1_5">
        <span className="size-16 fw-bold text-cool-gray-10">Have feedback for this dealer?</span>
        <div className="d-flex align-items-start column-gap-2 row-gap-1 flex-column flex-md-row">
          <WriteAReviewLink params={params} reviewsType={REVIEWS_SALES} showroomPage={showroomPage} noFollow />
          <WriteAReviewLink params={params} reviewsType={REVIEWS_SERVICE} showroomPage={showroomPage} noFollow />
        </div>
      </div>
    </div>
  );
}

DealerReviewNoReviewsView.propTypes = {
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string,
  isMobile: PropTypes.bool,
  showroomPage: PropTypes.string,
};
